import * as React from "react";
import type { SVGProps } from "react";
const SvgGitlabLogo500Rgb = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="gitlab-logo-500-rgb_svg__Layer_1"
    data-name="Layer 1"
    viewBox="100 110 180 160"
    {...props}
  >
    <defs>
      <style>{".gitlab-logo-500-rgb_svg__cls-2{fill:#fc6d26}"}</style>
    </defs>
    <path
      d="m265.264 174.372-.213-.558-21.2-55.309a5.48 5.48 0 0 0-2.176-2.627 5.64 5.64 0 0 0-6.531.348 5.57 5.57 0 0 0-1.875 2.854l-14.314 43.806h-57.91l-14.312-43.806a5.57 5.57 0 0 0-1.875-2.854 5.64 5.64 0 0 0-6.531-.348 5.48 5.48 0 0 0-2.178 2.627l-21.198 55.313-.214.554c-6.282 16.386-.93 34.908 13.059 45.488q.038.026.076.056l.187.141 32.29 24.174 15.972 12.09 9.72 7.35a6.56 6.56 0 0 0 7.92 0l9.72-7.35 15.967-12.09 32.482-24.315.085-.066c13.978-10.58 19.327-29.096 13.05-45.478"
      style={{
        fill: "#e24329",
      }}
    />
    <path
      d="m265.264 174.372-.213-.558a71.6 71.6 0 0 0-28.499 12.816c-.134.099-25.205 19.058-46.551 35.197 15.85 11.985 29.647 22.404 29.647 22.404l32.482-24.315.085-.066c13.978-10.58 19.327-29.096 13.05-45.478"
      className="gitlab-logo-500-rgb_svg__cls-2"
    />
    <path
      d="m160.35 244.231 15.971 12.09 9.72 7.35a6.56 6.56 0 0 0 7.92 0l9.72-7.35 15.967-12.09s-13.797-10.419-29.647-22.404c-15.854 11.985-29.651 22.404-29.651 22.404"
      style={{
        fill: "#fca326",
      }}
    />
    <path
      d="M143.446 186.63a71.5 71.5 0 0 0-28.495-12.812l-.214.554c-6.282 16.386-.93 34.908 13.059 45.488q.038.026.075.056l.188.141 32.29 24.174s13.798-10.419 29.652-22.404c-21.347-16.139-46.42-35.098-46.555-35.197"
      className="gitlab-logo-500-rgb_svg__cls-2"
    />
  </svg>
);
export default SvgGitlabLogo500Rgb;
